export default "__VITE_ASSET__D1uNVs$k__"